import React, { useState } from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
import LocationPinIcon from '@mui/icons-material/LocationPin';

const HdfcCredilaLendingPartner = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Landing Partner"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Landing Partner"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    const uniqueFeatures = [
        {
            title: "1. Can the HDFC Credila education loan cover the entire cost of education?",
            content: "Yes, the full cost of your study abroad is covered by the HDFC Credila education loan."
        },
        {
            title: "2. Can I receive any tax benefits for the interest paid on the HDFC Credila education loan?",
            content: "You can get tax benefits on the interest paid for education loans under Section 80-E of the Income Tax Act."
        },
        {
            title: "3. What is the duration for HDFC Credila loan approval?",
            content: "It usually takes 3-4 business days for approval after submitting the required documentation."
        },
        {
            title: "4. Are payments necessary while pursuing studies with an HDFC Credila education loan?",
            content: "Simple interest will be required for payment. However, if you have a good profile, there is an option to repay only a portion of the interest."
        }, {
            title: "5. What is the current interest rate for the HDFC Credila education loan?",
            content: "The interest rate can vary from 10.25% to 12.75% depending on different factors."
        }, {
            title: "6. What is the fee charged for processing the HDFC Credila education loan?",
            content: "The HDFC Credila education loan has a processing charge that ranges from 1% to 1.25% of the loan balance."
        }
    ];

    const [openIndex, setOpenIndex] = useState(null);
    const handleAccordion = idx => {
        setOpenIndex(openIndex === idx ? null : idx);
    };
    return (
        <>
            <BannerBreadcrumb head={"HDFC Credila Loan"} parades={"Get Free Education Loan Assistance From Credere"} pagename={"HDFC Credila Loan"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <h5 className="about-head">HDFC Credila Education Loan for Abroad Studies</h5>
                            <p className="loan-elegibility-des">A major player in the NBFC market, HDFC Credila has helped many students achieve their academic goals. HDFC Credila Financial Services is India’s foremost education loan provider. They specialize in providing loans to students who wish to study abroad. They have tie-ups with more than 1000 universities in at least 35 countries. HDFC Credila stands out because it offers personalized education loan options that consider the applicant’s course and country preferences.</p>


                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>Description	</th>


                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td className="">
                                            Rate of interest</td>
                                        <td className="">

                                            10.25% - 12.75%
                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Loan amount</td>
                                        <td className="">
                                            Up to INR 65 Lakh

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Processing fees</td>
                                        <td className="">

                                            0.5-1%

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Processing time
                                        </td>

                                        <td className="">
                                            7-10 days</td>

                                    </tr>
                                    <tr>
                                        <td className="">

                                            Margin money</td>
                                        <td className="">

                                            Nil
                                        </td>


                                    </tr>

                                    <tr>
                                        <td>
                                            Moratorium Period</td>
                                        <td>Course duration + 1-year</td></tr>
                                    <tr>
                                        <td>Repayment tenure</td>
                                        <td>15 years</td>
                                    </tr>

                                </tbody>
                            </table>
                            <p className="loan-elegibility-des">You are given a moratorium period where you don’t have to make any payments towards your education loan.
                                <br /><br />
                                The borrower must provide a certain amount of money called margin money for the loan, and the lender will cover the rest.</p>
                            <h5 className="about-head">Enjoy Tax Benefits with HDFC Credila's Offerings</h5>
                            <p className="loan-elegibility-des">Only HDFC Credila, an NBFC in India, offers tax benefits on education loans under Section 80E. Individuals may avail of a deduction for the interest paid on an education loan under Section 80E of the Income Tax Act. This deduction is applicable for a maximum of eight years, starting from the year when the loan repayment begins. It’s crucial to understand that Section 80E tax benefit is limited to the interest paid on education loans, not the principal amount.</p>
                            <h5 className="about-head">HDFC Credila Education Loan Scheme's Eligibility Criteria</h5>
                            <h5 className="about-head">Age</h5>

                            <p className="loan-elegibility-des">The applicant must be a citizen of India and must be 18 years of age or older at the time of application. Additionally, the student must have obtained admission to a recognized university.</p>


                            <h5 className="about-head">Academic Performance</h5>
                            <p className="loan-elegibility-des">A strong emphasis is placed on the applicant’s academic performance. Meeting the minimum academic requirements set by the lending institution is crucial. Furthermore, the applicant must demonstrate proficiency in prerequisite tests such as GRE, IELTS, or TOEFL.</p>

                            <h5 className="about-head">Co-applicant</h5>
                            <p className="loan-elegibility-des">To qualify for the loan, the borrower must have a co-applicant, who can be their mother, father, sister, brother, spouse, relative from either side of the family, or a legal guardian. The co-applicant is required to have a reliable source of income and a positive credit history.</p>
                            <h5 className="about-head">Course and Country of Study</h5>
                            <p className="loan-elegibility-des">The plan covers a broad range of courses, which include standard graduate degrees, postgraduate degrees, diplomas, certificates, and doctorate courses provided by foreign institutes and universities in countries like the USA, UK, France, Canada, Australia, New Zealand, Germany, and Ireland, among others.</p>
                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
                                <form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>

                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div className="col-md-12 loan-eligibility">

                            <h5 className="about-head">HDFC Credila Education Loan for US</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>GRE  &gt;=310	</th>
                                        <th>GRE 300 - &lt; 310	</th>
                                        <th>GRE 285 - &lt; 299</th>
                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td>Rate of interest</td>
                                        <td></td>
                                        <td></td>
                                        <td>12.5 - 13%</td>
                                    </tr>
                                    <tr>
                                        <td>Loan amount</td>
                                        <td>Up to INR 65 Lakh</td>
                                        <td>Up to INR 50 Lakh</td>
                                        <td>Up to INR 40 Lakh</td>
                                    </tr>
                                    <tr>
                                        <td>Co-applicant minimum income</td>
                                        <td>INR 30K</td>
                                        <td>INR 35K</td>
                                        <td>INR 35K</td>
                                    </tr>
                                    <tr>
                                        <td>Monthly installment during the course</td>
                                        <td>Partial simple interest</td>
                                        <td>Partial simple interest</td>
                                        <td> simple interest</td>
                                    </tr>
                                    <tr>
                                        <td>Processing fees</td>
                                        <td>0.5-1%</td>
                                        <td>0.7 - 1%</td>
                                        <td>1%</td>
                                    </tr>

                                </tbody>
                            </table>

                            <h5 className="about-head">HDFC Credila Education Loans for Other Countries</h5>
                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>Australia / New Zealand		</th>
                                        <th>Canada</th>
                                        <th>UK</th>
                                        <th>Germany/Ireland/
                                            France/Italy</th>
                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td>
                                            Rate of interest
                                        </td>
                                        <td>12 - 13%</td>
                                        <td>11.75 - 12.5%</td>
                                        <td>12 - 13%</td>
                                        <td>12 - 12.75%</td>
                                    </tr>
                                    <tr>
                                        <td>Loan amount</td>
                                        <td>INR 25 Lakh</td>
                                        <td>INR 40 Lakh</td>
                                        <td>INR 40 Lakh</td>
                                        <td>INR 25 Lakh</td>
                                    </tr>
                                    <tr>
                                        <td>Co-applicant minimum income</td>
                                        <td>INR 60K</td>
                                        <td>INR 35K</td>
                                        <td>INR 40K</td>
                                        <td>INR 40K</td>
                                    </tr>
                                    <tr>
                                        <td>Monthly installment during the course</td>
                                        <td>Simple interest/ EMI</td>
                                        <td>Partial simple interest</td>
                                        <td>Simple interest/ Partial interest</td>
                                        <td>Simple interest/ Partial interest</td>
                                    </tr>
                                    <tr>
                                        <td>Processing fees</td>
                                        <td>1%</td>
                                        <td>0.75-1%</td>
                                        <td>1 - 2%</td>
                                        <td>1 - 1.5%</td>
                                    </tr>

                                </tbody>
                            </table>


                            <h5 className="about-head">Documents Needed to Apply for an HDFC Credila Education Loan</h5>


                            <p className="loan-elegibility-des">For HDFC Credila education loans, Credere offers a personalized documents list based on your profile, the profiles of your co-applicants, and any assets or property you might want to submit as collateral.</p>


                            <h6 className="subhead mt-4">Documents Submitted by the Applicant</h6>
                            <ol className="subhead-ul">
                                <li>Education loan application form.</li>
                                <li>Identity proof: Passport / PAN / Driver’s License/ Government-issued identification document or Voter ID card.</li>
                                <li>Address proof: recent copy of electricity bill/telephone bill / Aadhaar card / piped gas bill/ Driving License/ water bill.</li>
                                <li>Past academic record</li>
                                <li>Passport</li>
                                <li>Undergraduate result (semester-wise)</li>
                                <li>10th standard mark sheet</li>
                                <li>12th standard mark sheet</li>
                                <li>Statement of expenses</li>
                                <li>Entrance exam results (e.g. GRE, GMAT, TOEFL, etc.)</li>
                                <li>Proof of admission: admission letter (A conditional admission letter is also applicable).</li>
                            </ol>
                            <h6 className="subhead">Co-applicants Documents</h6>
                            <ol className="subhead-ul">
                                <li>Address: recent copy of telephone bill/ electricity bill/ Aadhaar card/water bill/ piped gas bill or copy of Driving license.</li>
                                <li>Identity proof: Driver’s license/PAN/ Passport/ Voter ID card or government-issued identification document.</li>
                                <li>2 passport-size photographs.</li>
                                <li>Bank account statement of the co-borrower/guarantor, for the last 6 months (in case of takeover of education loan).</li>
                                <li>Income proof for salaried co-applicant/guarantor
                                    <ol className="subhead-ul">
                                        <li>Salary slips for the last 3 months.</li>
                                        <li>Copy of Form 16 of the last 2 years or copy.</li>
                                        <li>Brief statement of assets & liabilities of parent/ guardian/ other co-borrower</li>
                                        <li>Bank account statement for the last 6 months (Salary account).</li>
                                    </ol>
                                </li>

                                <li>Income proof for self-employed co-applicant/guarantor
                                    <ol className="subhead-ul">
                                        <li>Last 2 years IT returns ( If IT Payee).</li>
                                        <li>Business address proof.</li>
                                        <li>TDS certificate (Form 16A, if applicable)
                                            <ol className="subhead-ul">
                                                <li>Bank account statement for the last 6 months</li>
                                                <li>Certificate of qualification (for C.A./ doctor and other professionals).</li>
                                            </ol>
                                        </li>

                                        <li>Brief statement of assets & liabilities of parent/ guardian/ other co-borrower.</li>
                                    </ol>
                                </li>

                            </ol>
                            <h5 className="about-head">Steps for Applying for an Education Loan at HDFC Credila Through Credere</h5>
                            <p className="loan-elegibility-des">Those seeking financial assistance for studying abroad may access HDFC Credila’s online platform to initiate the loan application process. Alternatively, for an easy and efficient application procedure, applicants can consider utilizing Credere’s services to apply for their education loan.
                                <br /><br />
                                Credere serves as an internet-based platform that aims to support Indian students in funding their overseas education. To initiate your journey with us, simply verify your eligibility for a loan as well as entrust the remaining tasks to our proficient team.</p>


                            <h5 className="about-head">Benefits of obtaining a HDFC Credila Educational Loan through Credere</h5>

                            <p className="loan-elegibility-des"><b>The Best Loan Available</b></p>
                            <p className="loan-elegibility-des">Credere strives to deliver the most favorable education loan deals to our customers. Our team works regularly to negotiate the best terms and conditions for your loan, ensuring that you have access to the most beneficial options in the market.</p>
                            <p className="loan-elegibility-des"><b>Trouble-free Experience</b></p>
                            <p className="loan-elegibility-des">If you apply for an education loan directly, you may encounter several difficulties. However, Credere offers a solution that streamlines the entire process. By simply checking your eligibility, you can bypass the potential challenges that may arise. Once you are confirmed as eligible, you may relax and rely on the expertise of a dedicated education loan counselor who will guide you every step of the way.</p>
                            <p className="loan-elegibility-des"><b>Services Offered Completely Free of Cost</b></p>
                            <p className="loan-elegibility-des">Credere offers its services to candidates without any charges. We do not require applicants to pay any processing fees or commissions for utilizing our services. </p>
                            <p className="loan-elegibility-des"><b>Greater Possibility of Being Approved</b></p>
                            <p className="loan-elegibility-des">If there are any issues with the paperwork or application, Credere steps in to address and overcome the issue by liaising with the authorities at HDFC Credila.</p>
                            <p className="loan-elegibility-des"><b>Quick Processing Time</b></p>
                            <p className="loan-elegibility-des">In approximately 5-7 days, Team Credere successfully collaborates with many HDFC Credila departments to obtain a loan approval. Because of this, each year thousands of students entrust us with their student loans. A student’s loan application would normally be processed within 12 to 15 days if they applied directly to the NBFC.</p>

                            <h5 className="about-head mt-4"> FAQ (Frequently Asked Questions) </h5>


                            {uniqueFeatures.map((item, idx) => (
                                <div className={`accordion-item${openIndex === idx ? ' open' : ''}`} key={idx}>
                                    <button className="accordion-title" onClick={() => handleAccordion(idx)}>
                                        {item.title}
                                        <span className="accordion-arrow">{openIndex === idx ? '-' : '+'}</span>
                                    </button>
                                    <div className="accordion-content" style={{ maxHeight: openIndex === idx ? '500px' : '0' }}>
                                        <p className="loan-eligibility-des mb-0">{item.content}</p>
                                        <p className="loan-eligibility-des mt-3"><b>{item.head}</b>{item.content1}</p>
                                        <p className="loan-eligibility-des"><b>{item.head1}</b>{item.content2}</p>
                                    </div>
                                </div>

                            ))}
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default HdfcCredilaLendingPartner;